<template>
  <div class="inspection-container">
    <div class="layout-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/inspection-banner.png"
        alt="" class="pc-banner" />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile_inspection_bg.png"
        alt="" class="mobile-banner">
      <div class="text-block">
        <div class="title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">
          巡检精灵APP
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          智能飞行 巡检无忧
        </div>
        <div class="use-button wow fadeInUp" @click="openCodeDialog" data-wow-delay="0.7s">
          申请试用
        </div>
      </div>
    </div>

    <div class="block-wrap" style="background-color:#F5F7FA;">
      <div class="block-title page-block-title">产品简介</div>
      <div class="block-desc page-block-desc">根据作业范围及电站类型，控制无人机自主巡检作业，垂直光伏组件，温度数据更精准，适配所有电站类型。</div>
      <div class="content-wrap">
        <!-- xjjl_img1 -->
        <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img1.png"
          alt="" />
      </div>
    </div>

    <!-- <div class="block-content-box">
        <div class="block-content-title">镜头垂直光伏组件拍摄</div>
        <div class="block-content-bg">
          <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img2.png" alt="">
        </div>
     </div>
   -->
    <div class="block-wrap">
      <div class="block-title page-block-title">智能巡检</div>
      <div class="block-content">
        <div class="content-row">
          <div class="row-left">
            <div class="img-wrap wow fadeInLeft" data-wow-delay="0.3s">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img2.png"
                alt="" />
            </div>
          </div>
          <div class="row-right">
            <div class="block-text  wow fadeInRight" data-wow-delay="0.3s">
              <div class="title">镜头垂直光伏组件拍摄</div>
              <div class="desc">减少透视畸变，避免反光，确保图像清晰准确，从而提高检测效率和定位精度，为光伏电站的运维管理提供有力支持。</div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left">
            <div class="block-text wow fadeInLeft" data-wow-delay="0.3s">
              <div class="title">仿地飞行</div>
              <div class="desc">无惧复杂地形、提升成像质量、确保飞行安全</div>
            </div>
          </div>
          <div class="row-right">
            <div class="img-wrap wow fadeInRight" data-wow-delay="0.3s">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img9.png"
                alt="" />
            </div>
          </div>
        </div>

        <!-- <div class="content-row">
            <div class="row-left">
              <div class="img-wrap wow fadeInLeft" data-wow-delay="0.3s">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img5.png" alt="" />
              </div>
            </div>
            <div class="row-right">
              <div class="block-text wow fadeInRight" data-wow-delay="0.3s">
                <div class="title">单轴跟踪</div>
                <div class="desc">
                </div>
              </div>
            </div>
          </div>
  
          <div class="content-row">
            <div class="row-left">
              <div class="block-text wow fadeInLeft" data-wow-delay="0.3s">
                <div class="title">多轴跟踪</div>
                <div class="desc">程序自动跟踪组件朝向，精准采集组件温度数据。</div>
              </div>
            </div>
            <div class="row-right">
              <div class="img-wrap wow fadeInRight" data-wow-delay="0.3s">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img6.png" alt="" />
              </div>
            </div>
          </div> -->
      </div>
    </div>


    <!-- <div class="block-content-box">
        <div class="block-content-title">仿地飞行</div>
        <div class="block-content-bg">
          <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img9.png" alt="">
        </div>
     </div> -->

    <!-- 无人机系列 -->
    <div class="airplane-wrap ">
      <div class="block-title page-block-title">支持所有电站类型</div>
      <div class="airplane-content pc-station-block">
        <div class="content-item" :class="{ on: activeIndex == '1' }" @mouseover="expandItem('1')">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img4.png"
            alt="">
          <div class="text-block">
            <div class="text-title">平铺电站</div>
          </div>
        </div>
        <div class="content-item" :class="{ on: activeIndex == '2' }" @mouseover="expandItem('2')">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img5.png"
            alt="">
          <div class="text-block">
            <div class="text-title">斜铺电站</div>
          </div>
        </div>
        <div class="content-item" :class="{ on: activeIndex == '3' }" @mouseover="expandItem('3')">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img6.png"
            alt="">
          <div class="text-block">
            <div class="text-title">山地电站</div>
          </div>
        </div>
        <div class="content-item" :class="{ on: activeIndex == '4' }" @mouseover="expandItem('4')">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img7.png"
            alt="">
          <div class="text-block">
            <div class="text-title">单轴跟踪</div>
          </div>
        </div>

        <div class="content-item" :class="{ on: activeIndex == '5' }" @mouseover="expandItem('5')">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img8.png"
            alt="">
          <div class="text-block">
            <div class="text-title">多轴跟踪</div>
          </div>
        </div>
      </div>
      <div class="mobile-station-block">
        <inspectionStationCarousel></inspectionStationCarousel>
      </div>
    </div>


    <div class="mask" v-if="codeDialogFlag">
      <codeCard @closeDialog="closeDialog" :codeDialogFlag="codeDialogFlag"></codeCard>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import codeCard from "./components/inspection-code.vue"
import inspectionStationCarousel from "./components/inspection-station-carousel.vue"


export default {
  components: {
    codeCard,
    inspectionStationCarousel
  },
  data() {
    return {
      activeChoose: "simple",
      codeDialogFlag: false,
      activeIndex: "1"
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  methods: {
    closeDialog() {
      this.codeDialogFlag = false
    },
    openCodeDialog() {
      this.codeDialogFlag = true
    },
    expandItem(index) {
      this.activeIndex = index
    }
  },
};
</script>

<style lang="stylus" scoped>
  .mask {
    width: 100%;
    height:100vh;
    position:fixed;
    top:0;
    left:0;
    background: rgba(0,0,0,0.7);
    display:flex;
    justify-content:center;
    z-index:15;
    align-items:center;
}
.mobile-station-block {
  display:none;
}
.airplane-wrap {
  max-width: var(--main-width);
  width: 84%;
  margin:0 auto 6.91rem;
  .block-title {
    position:relative;
    position:relative;
    text-align:center;
    letter-spacing:2px;
    font-weight:bold;
}

  .airplane-content {
    display:flex;
    overflow:hidden;
    margin-top:3.25rem;
    .content-item {
      width: 9.25%;
      flex: 1 0 9.25%;
      height:24.38rem;
      position:relative;
      transition: flex 0.3s ease, transform 0.3s ease;
      .text-block {
        position:absolute;
        left: 0;
        top: 0;
        padding: 2.75rem 0 0 2.88rem;
        color:#fff;
        .text-title {
          font-weight: 500;
          font-size: 1.63rem;
          color: #FFFFFF;
          line-height: 2.38rem;
          text-align: left;
          margin-bottom:1.56rem;
        }
        .list-item {
          margin-bottom:0.4rem;
          opacity:0;
        }
      }
    }
    .content-item img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      transition: object-position 0.3s ease;
  }
    .on {
      flex: 1 0 37.5% !important; /* 鼠标悬停时应用 .on 的样式 */
      .list-item {
        opacity:1 !important;
      }
    }

    .content-item.on img {
      object-position: 50% 50%; /* 可以根据实际情况调整，这里保持中间 */
  }
  }
}
  .inspection-container {
      width:100%;
      @keyframes zoomIn {
            0% {
              transform: scale(1.1); 
            }
            100% {
                transform: scale(1); 
            }
        }
      .layout-banner {
          height:100vh;
          position:relative;
          img {
            height:100%;
            width: 100%;
            object-fit: cover;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            transition: transform 0.3s ease-out;
            animation: zoomIn 3s ease-out forwards;
          }
          .text-block {
              position:absolute;
              top:50%;
              left:13%;
              transform: translateY(-50%);
              z-index: 2;
              color:#fff;
              .title {
                  font-size:3rem;
                  letter-spacing: 2px;
                  font-weight: bold;
                  margin-bottom:1.44rem;
              }
              .desc {
                  letter-spacing: 2px;
                  width:625px;
                  white-space: wrap;
                  font-size:1.25rem;
                  line-height:35px;
              }
              .use-button {
                  width:9rem;
                  height:2.875rem;
                  font-size:1.125rem;
                  letter-spacing:1px;
                  cursor:pointer;
                  background: #2372E9;
                  line-height:2.875rem;
                  text-align:center;
                  margin-top:6.18rem;
                  border-radius:30px;
              }
          }
      }
      .content-wrap {
        max-width: var(--main-width);
        width: 84%;
        margin:0 auto;
        padding-bottom:5.8rem;
        text-align:center;
          img {
              width:500px;
          }
      }
      .block-wrap {
          // width:calc(100% - 8rem);
          position:relative;
          padding-top:4.625rem;
          .block-title {
              position:relative;
              position:relative;
              text-align:center;
              letter-spacing:2px;
              font-weight:bold;
          }
              .block-desc {
                  margin:4.625rem auto 3.75rem;
                  line-height:32px;
                  text-align:center;
              }
      }
  
      .block-content {
          max-width:var(--main-width);
          width:84%;
          margin:7.56rem auto 0;
          margin-top:7.56rem;
          .content-row {
              display:flex;
              margin-bottom:4rem;
              >div {
                  flex:1;
              }
              .block-text {
                  padding:3rem 5.5rem;
                  .title {
                      color:#2372E9;
                      margin-bottom:3.18rem;
                      font-size:1.75rem;
                      font-weight:bold;
                  }
                  .desc {
                      color:#333333;
                      line-height:30px;
                      font-size:1rem;
                  }
              }
          }
      }
      .block-content-box {
          max-width:var(--main-width);
          width:84%;
          margin:0 auto;
          .block-content-title {
              text-align:center;
              position:relative;
              font-size:2.625rem;
              position:relative;
              text-align:center;
              letter-spacing:2px;
              font-weight:bold;
          }
          .block-content-title::after {
              content:"";
              position:absolute;
              width: 55px;
              left:50%;
              transform:translateX(-50%);
              top:80px;
              height: 3px;
              background: #2372E9;
              }
          }
          .block-content-bg {
              
              margin:4.5rem auto;
              width:100%;
              display:flex;
              justify-content: center;
          }
  }
  @media only screen and (max-width: 1200px) and (min-width: 768px) {
      .content-row {
          flex-wrap:wrap;
          .img-wrap {
              height:425px;
              overflow:hidden;
              text-align:center;
              
          }
          .row-left,.row-right {
              width:100%;
              flex:auto !important;
          }
      }
  }
  @media only screen and (max-width: 768px) {
.inspection-container {
  .airplane-wrap {
      margin-bottom:65px;
    }
    .content-wrap {
      padding-bottom:30px;
      img {
        width:345px !important;
      }
    }
    .content-wrap,.block-content-box {
      width:auto !important;
    }
    .pc-station-block {
      display:none !important;
    }
    .mobile-station-block {
      display:block !important;
      margin-top:50px;
    }
      .content-row {
          flex-wrap:wrap;
          .img-wrap {
              overflow:hidden;
              display:flex;
              justify-content:center;
              // img {
              //     width:100%;
              // }
          }
          .row-left,.row-right {
              width:100%;
              flex:auto !important;
          }
      }
      .layout-banner {
        height:380px;
        margin-top:108px;
       
        .text-block {
            transform:translateY(0);
            top:131px;
             .title {
            font-size:24px;
            margin-bottom:10px;
        }
        .desc {
            line-height:20px;
          }
        }
        .use-button {
            display:none;
        }
    }
    .block-title {
      font-size:22px !important;
  }
  .block-title::after {
    top:40px !important;
}
    .block-wrap {
      width:calc(100% - 30px );
      margin:0;
      padding:25px 15px 0;
      .block-content {
        margin-top:30px;
        width:auto;
        .block-content-title {
          font-size:22px !important;
          padding-top:32px;
        }
         .content-row {
          margin-bottom:2rem ;
           .block-text {
          padding:20px 20px 0 20px;
          text-align:center;
          .title {
            margin-bottom:20px;
            font-size:18px;
          }
          .desc:nth-child(2) {
              margin-bottom:30px;
            }
          .desc {
            color:#222;
            font-size:14px;
            line-height:20px;
            }
        }
        }
      }
        .block-desc {
          padding:15px 15px 13px 15px;
          margin:0 ;
          font-size:14px;
          line-height:20px;
        }
    }

    
        .block-content-box {
          // margin:0 15px !important;
        }
        .block-content-bg {
          width:calc(100% - 30px) !important;
          margin:39px auto !important;
          img {
            width:100%;
          }
        }
        .img-wrap {
          img {
            width:490px;
          }
        }
   
       
        }
  }
  </style>